<div class="flex flex-col flex-1-0-100" *ngIf="!componentDisabled">
  <div class="flex flex-row justify-between items-center">
    <h3 class="component-heading">{{displayLabel}}
      <!--<a class="fake-link" id="fake-link-1" (click)="onSelect()">(Reverse Direction)</a>-->
    </h3>
    <div class="flex flex-row justify-start items-center">
      <label class="component-label">Sort:
        <mat-form-field class="no-placeholder-animation tiny-selector">
          <mat-select [(value)]="selectedSortOption" (selectionChange)="onSortOptionChange()">
            <mat-option *ngFor="let option of sortOptions"
                        [value]="option.value">
              {{option.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </label>
    </div>
  </div>

  <div class="flex flex-row justify-start items-start">
    <form [formGroup]="Form" class="full-grow-no-shrink-no-basis">
      <mat-form-field class="orbitax-search-field" appearance="outline" class="flex-1-1-100">
        <mat-label>Search</mat-label>
        <input formControlName="search" matInput placeholder="Search..." [(ngModel)]="searchText">
      </mat-form-field>
    </form>
  </div>

  <div class="simple-scroll flex flex-col" style="height: 0;flex-grow: 1">

    <div *ngFor="let country of (countryListViewModel | searchTransactionByCountryName: searchText);index as i"
         (click)="selectCounty(country,i)"
         particleAnalytics
         analyticsCategory="country-setting"
         analyticsAction="transaction-country-setting"
         [analyticsName]="country.entity.title"
         [ngClass]="{'selection-list-items-selected': sectedIndex === i}"
         class="selection-list-items">
      <span [style.visibility]="country.isChecked ? 'visible' : 'hidden'">  <mat-icon>check</mat-icon></span>
      <span>{{country.entity.title}}</span>
    </div>
  </div>


</div>
<div *ngIf="componentDisabled" class="empty-hint m-t-20">
  <div>
    <h1> Add Transaction:</h1>
    <div>
      Select a Paying country followed by a Receiving country followed by checking one or more Streams to add the
      separate transactions.
    </div>
  </div>

  <div class="m-t-25">
    <h1>Remove Transaction:</h1>
    <div>
      Select a ✓ Paying country followed by a ✓ Receiving country followed by unchecking one or more Streams to remove
      the separate transactions.
    </div>
  </div>
</div>





